<template>
  <IndexBase
    @auth="onAuth($event)"
    action="Index"
    controller="Permit"
  ></IndexBase>

  <Dialog
    :header="$t('release_confirmation')"
    v-model:visible="showApprovalConfirmationModal"
    :closeOnEscape="false"
    :closable="false"
    :modal="true"
    :breakpoints="{ '960px': '75vw', '640px': '100vw' }"
    :style="{ width: '50vw' }"
  >
    <div>
      {{ this.$t("message.release_confirmation") + confirmationStatus }}
      <!-- 
            <ul v-for="(doc) in selectedDocuments" v-bind:key="doc.id">
               <li>{{doc.ref_no}}</li> 
            </ul> -->

      <div v-if="!processed">
        <div v-for="doc in selectedRow" v-bind:key="doc.PermitNumber">
          <div class="grid">
            <div class="col-5">
              {{ doc.PermitNumber }}
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div v-for="item in resultData" v-bind:key="item.ref_no">
          <div class="grid">
            <div class="col-5">
              {{ item.ref_no }}
            </div>
            <div class="col-6">
              <div class="p-fluid">
                <InputText
                  type="text"
                  class="p-inputtext-sm"
                  v-model="item.remarks"
                  :disabled="true"
                />
              </div>
            </div>
            <div class="col-1">
              <div v-if="item.success">
                <Tag
                  class="mr-2"
                  :value="
                    confirmationStatus == $APPROVAL_STATUS.APPROVED
                      ? 'Approved'
                      : 'Rejected'
                  "
                >
                </Tag>
              </div>
              <div v-else>
                <Tag class="mr-2" severity="danger" :value="item.message"></Tag>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <template #footer>
      <div v-if="processed">
        <Button label="Close" @click="dismissConfirmation" />
      </div>
      <div v-else>
        <div v-if="processing" style="float: right !important">
          <ProgressSpinner style="width: 50px; height: 50px" />
        </div>
        <div v-else>
          <div v-if="!processed">
            <Button label="No" @click="dismissConfirmation" />
            <Button
              label="Yes"
              autofocus
              @click="confirmApproval"
              class="pi-button p-button-success"
            />
          </div>
          <div v-else>
            <Button
              label="Close"
              icon="pi pi-times"
              class="p-button-text"
              @click="onClose"
            />
          </div>
        </div>
      </div>
    </template>
  </Dialog>

  <Card>
    <template #title>
      <Toolbar>
        <template #left>
          <div class="p-card-title">Permit</div>
        </template>

        <template #right>
          <Button
            class="pi-button p-button-success"
            :label="$t('release')"
            v-if="selectedRow != null && selectedRow.length > 0 && this.unrel"
            @click="processSelectedData($PERMIT.RELEASE)"
          />
        </template>
      </Toolbar>
    </template>
    <template #content>
      <div class="p-fluid mb-3">
        <CustomSelectButton
          v-model="selectedType"
          :options="typeList"
          optionLabel="option"
          class="p-text-center"
          @change="onTypeChange"
          :setDefault="true"
        >
          <template #option="slotProps">
            <div class="p-text-center" style="width: 100%">
              {{ slotProps.option }}
            </div>
          </template>
        </CustomSelectButton>
      </div>

      <div class="p-fluid mb-3">
        <CustomSelectButton
          v-model="selectedStatus"
          :options="statusList"
          optionLabel="option"
          class="p-text-center"
          @change="onStatusChange"
          :setDefault="true"
        >
          <template #option="slotProps">
            <div class="p-text-center" style="width: 100%">
              {{ slotProps.option }}
            </div>
          </template>
        </CustomSelectButton>
      </div>

      <DataTable
        ref="dt"
        responsiveLayout="scroll"
        class="p-datatable-sm"
        filterDisplay="row"
        sortMode="multiple"
        removableSort
        v-model:expandedRows="expandedRows"
        stateStorage="local"
        :stateKey="stateKey"
        :value="dataModel"
        :loading="!dataModel || loading"
        :paginator="true"
        :rows="pageSize"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        :rowsPerPageOptions="[10, 20, 50]"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        :lazy="true"
        v-model:first="this.start"
        @rowExpand="onRowExpand"
        @state-restore="onStateRestore($event)"
        @state-save="onStateSave($event)"
        @page="onPage($event)"
        @sort="onSort($event)"
        @filter="onFilter($event)"
        @update:selection="onSelect($event)"
        @row-dblclick="onRowDoubleClick"
        v-model:filters="filters"
        :totalRecords="totalRecords"
        v-model:selection="selectedRow"
        selectionMode="multiple"
        dataKey="Id"
        :rowClass="rowClass"
        :metaKeySelection="false"
        id="dataPermit"
      >
        <Column
          :exportable="false"
          :sortable="false"
          headerStyle="white-space:nowrap"
        >
          <template #header="">
            <Button
              :label="$t('create')"
              icon="pi pi-plus"
              v-show="canCreate"
              class="p-button-primary p-button-sm"
              @click="initWork(this.$FORM_MODE_CREATE, 0)"
            />
          </template>
          <template #filter>
            <Button
              :label="$t('clear')"
              icon="pi pi-filter-slash"
              class="p-button-outlined p-button-primary p-button-sm"
              @click="clearFilter"
              :badge="filterBadge"
              badgeClass="p-badge-danger"
            />
          </template>
          <template #body="dataModel">
            <Button
              icon="pi pi-search"
              v-show="canView"
              class="p-button-rounded p-button-info mr-2 p-button-sm"
              @click="
                editor(
                  this.$FORM_MODE_VIEW,
                  dataModel.data.Id,
                  dataModel.data.Status
                )
              "
              v-tooltip.bottom="'View'"
            />
            <Button
              icon="pi pi-print"
              class="p-button-rounded p-button-warning mr-2 p-button-sm"
              @click="downloadPrint($event, 'PDF', dataModel.data.Id)"
              v-tooltip.bottom="'Print'"
              v-if="dataModel.data.Status != 'OPN'"
            />
            <Button
              icon="pi pi-desktop"
              class="p-button-rounded p-button-help mr-2 p-button-sm"
              @click="editorWork(this.$FORM_MODE_VIEW, dataModel.data.WorkId)"
              v-tooltip.bottom="'Work Detail'"
            />
            <Button
              icon="pi pi-send"
              class="p-button-rounded p-button-secondary mr-2 p-button-sm"
              @click="
                confirm(
                  $event,
                  this.$FORM_MODE_COPY,
                  dataModel.data.Id,
                  dataModel.data.WorkId,
                  dataModel.data.Category
                )
              "
              v-tooltip.bottom="'Continue Permit'"
              v-if="
                (this.inprogress &&
                  this.username == dataModel.data.PermitUser &&
                  dataModel.data.IsDeleted == 'N' &&
                  (dataModel.data.AdvancedContinuePermit == 'N' ||
                    dataModel.data.AdvancedContinuePermit == null)) ||
                (this.completed &&
                  this.username == dataModel.data.PermitUser &&
                  dataModel.data.IsDeleted == 'N') ||
                (this.closed &&
                  this.username == dataModel.data.PermitUser &&
                  dataModel.data.IsDeleted == 'N') ||
                (this.all &&
                  this.username == dataModel.data.PermitUser &&
                  dataModel.data.IsDeleted == 'N' &&
                  dataModel.data.Status == 'PRG' &&
                  (dataModel.data.AdvancedContinuePermit == 'N' ||
                    dataModel.data.AdvancedContinuePermit == null)) ||
                (this.all &&
                  this.username == dataModel.data.PermitUser &&
                  dataModel.data.IsDeleted == 'N' &&
                  dataModel.data.Status == 'CLS') ||
                (this.all &&
                  this.username == dataModel.data.PermitUser &&
                  dataModel.data.IsDeleted == 'N' &&
                  dataModel.data.Status == 'COM')
              "
            />
            <Button
              icon="pi pi-pencil"
              v-show="canEdit"
              class="p-button-rounded p-button-success mr-2 p-button-sm"
              @click="
                editor(
                  this.$FORM_MODE_EDIT,
                  dataModel.data.Id,
                  dataModel.data.Status
                )
              "
              v-tooltip.bottom="'Edit'"
              v-if="
                (this.unrel &&
                  this.username == dataModel.data.PermitUser &&
                  dataModel.data.IsDeleted == 'N') ||
                (this.rejecteed &&
                  this.username == dataModel.data.PermitUser &&
                  dataModel.data.IsDeleted == 'N') ||
                (this.all &&
                  this.username == dataModel.data.PermitUser &&
                  dataModel.data.IsDeleted == 'N' &&
                  (dataModel.data.Status == 'OPN' ||
                    dataModel.data.Status == 'REJ'))
              "
            />
            <Button
              icon="pi pi-trash"
              v-show="canDelete"
              class="p-button-rounded p-button-danger mr-2 p-button-sm"
              @click="
                editor(
                  this.$FORM_MODE_DELETE,
                  dataModel.data.Id,
                  dataModel.data.Status
                )
              "
              v-tooltip.bottom="'Delete'"
              v-if="
                (this.unrel &&
                  this.username == dataModel.data.PermitUser &&
                  dataModel.data.IsDeleted == 'N') ||
                (this.rejecteed &&
                  this.username == dataModel.data.PermitUser &&
                  dataModel.data.IsDeleted == 'N') ||
                (this.all &&
                  this.username == dataModel.data.PermitUser &&
                  dataModel.data.IsDeleted == 'N' &&
                  (dataModel.data.Status == 'OPN' ||
                    dataModel.data.Status == 'REJ'))
              "
            />

            <Button
              icon="pi pi-undo"
              v-if="dataModel.data.IsDeleted == 'Y' && this.isAdmin == 'Y'"
              class="p-button-rounded p-button-danger mr-2 p-button-sm"
              @click="
                confirmCancelDelete(
                  $event,
                  this.$RUN_WORK.CANCEL_DELETE,
                  dataModel.data.Id,
                  dataModel.data.WorkId,
                  dataModel.data.Category
                )
              "
              v-tooltip.bottom="'Cancel Delete'"
            />

            <ConfirmPopup></ConfirmPopup>
          </template>
        </Column>
        <Column
          field="PermitNumber"
          :header="$t('permit_number')"
          :sortable="true"
        >
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              :placeholder="$t('permit_number')"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          field="PermitDate"
          :header="$t('date')"
          dataType="date"
          :sortable="true"
        >
          <template #filter="{ filterModel, filterCallback }">
            <Calendar
              momentFormat="DD/MM/YYYY"
              class="p-column-filter p-inputtext-sm"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              :placeholder="$t('date')"
              @date-select="filterCallback()"
            />
          </template>
          <template #body="{ data }">
            {{ this.$formatDate(data.PermitDate) }}
          </template>
        </Column>
        <Column field="Status" :header="$t('status')" :sortable="true">
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              :placeholder="$t('status')"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column field="VendorCode" :header="$t('vendor')" :sortable="true">
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              :placeholder="$t('vendor')"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column field="AreaName" :header="$t('department')" :sortable="true">
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              :placeholder="$t('department')"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column field="CompanyCode" :header="$t('company')" :sortable="true">
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              :placeholder="$t('company')"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column field="Title" :header="$t('title')" :sortable="true">
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              :placeholder="$t('title')"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column field="Category" :header="$t('category')" :sortable="true">
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              :placeholder="$t('category')"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column field="Version" :header="$t('version')" :sortable="true">
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              :placeholder="$t('version')"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column field="IsOnline" :header="$t('is_online')" :sortable="true">
          <template #filter="{ filterModel, filterCallback }">
            <YNSelect
              :placeholder="$t('is_online')"
              :useBinary="true"
              v-if="filterModel"
              v-model="filterModel.value"
              @change="filterCallback()"
            />
          </template>
        </Column>
        <Column
          field="CreatedAt"
          :header="$t('created_date')"
          dataType="date"
          :sortable="true"
        >
          <template #filter="{ filterModel, filterCallback }">
            <Calendar
              inputMask="99/99/9999"
              momentFormat="DD/MM/YYYY"
              class="p-column-filter p-inputtext-sm"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              @date-select="filterCallback()"
              placeholder="Created Date"
            />
          </template>
          <template #body="{ data }">
            {{ this.$formatDateTime(data.CreatedAt) }}
          </template>
        </Column>

        <Column field="CreatedBy" :header="$t('created_by')" :sortable="true">
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
              placeholder="Created By"
            />
          </template>
        </Column>
        <Column
          field="EditedAt"
          :header="$t('edited_date')"
          dataType="date"
          :sortable="true"
        >
          <template #filter="{ filterModel, filterCallback }">
            <Calendar
              momentFormat="DD/MM/YYYY"
              class="p-column-filter p-inputtext-sm"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              placeholder="Edited Date"
              @date-select="filterCallback()"
            />
          </template>
          <template #body="{ data }">
            {{ this.$formatDateTime(data.EditedAt) }}
          </template>
        </Column>
        <Column field="EditedBy" :header="$t('edited_by')" :sortable="true">
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
              placeholder="Edited By"
            />
          </template>
        </Column>
        <Column field="IsDeleted" :header="$t('is_deleted')" :sortable="true">
          <template #filter="{ filterModel, filterCallback }">
            <YNSelect
              :placeholder="$t('is_deleted')"
              :useBinary="true"
              v-if="filterModel"
              v-model="filterModel.value"
              @change="filterCallback()"
            />
          </template>
        </Column>
        <Column field="DeletedAt" :header="$t('deleted_date')" :sortable="true">
          <template #filter="{ filterModel, filterCallback }">
            <Calendar
              inputMask="99/99/9999"
              momentFormat="DD/MM/YYYY"
              class="p-column-filter p-inputtext-sm"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              placeholder="Deleted Date"
              @date-select="filterCallback()"
            />
          </template>
          <template #body="{ data }">
            {{ this.$formatDateTime(data.DeletedAt) }}
          </template>
        </Column>
        <Column field="DeletedBy" :header="$t('deleted_by')" :sortable="true">
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
              placeholder="Deleted By"
            />
          </template>
        </Column>
      </DataTable>
    </template>
  </Card>

  <SelectCompany
    v-if="selectCompany"
    :isVisible="selectCompany"
    :userId="username"
    :requireCompany="true"
    @hide="hideSelectCompanyDialog"
    @block-ui="blockUI"
    @unblock-ui="unblockUI"
  />

  <Dialog
    header="Outstanding Permit"
    v-model:visible="isHaveOsPermit"
    :closeOnEscape="true"
    :closable="true"
    :modal="true"
    :breakpoints="{ '960px': '75vw', '640px': '100vw' }"
    :style="{ width: '60vw' }"
  >
    <span v-show="errMessage" class="p-error">{{ errMessage }}</span>
    <DataTable
      :loading="!dataPermitOS"
      :value="dataPermitOS ? dataPermitOS : null"
      responsiveLayout="scroll"
      class="p-datatable-sm editable-cells-table"
      :rowClass="setCurrentRow"
    >
      <Column
        field="osPermit"
        :header="$t('permit_number')"
        key="osPermit"
        style="width: 10%"
      >
        <template #body="slotProps">
          <!-- <a :href="'Permit/Editor?mode=View&id=' + data.Id" target="_blank">{{ data.Permit_Number }}
                        </a> -->
          <Button
            :label="slotProps.data.osPermit"
            class="p-button-text"
            @click="goToDetail(slotProps)"
          />
        </template>
      </Column>
      <Column
        field="createdByPermit"
        :header="$t('created_by')"
        key="createdByPermit"
        style="width: 10%"
      >
      </Column>
      <Column
        field="daysPermit"
        :header="$t('days')"
        key="daysPermit"
        style="width: 10%"
      >
      </Column>
      <Column
        field="statusPermit"
        :header="$t('status')"
        key="statusPermit"
        style="width: 10%"
      >
      </Column>
      <Column
        field="datePermit"
        :header="$t('date')"
        key="datePermit"
        style="width: 15%"
      >
        <template #body="{ data }">
          {{ this.$formatDate(data.datePermit) }}
        </template>
      </Column>
      <Column
        field="WillBeOSPermit"
        :header="$t('WillBeOSPermit')"
        key="WillBeOSPermit"
        style="width: 10%"
      >
      </Column>
    </DataTable>
  </Dialog>
</template>

<script>
import SelectCompany from "./_SelectCompany.vue";
export default {
  name: "Permit",
  components: {
    SelectCompany: SelectCompany,
  },
  data() {
    return {
      urlInit: this.$API_URL + "permit/initpermit",
      urlOsPermit: this.$API_URL + "permit/ospermit",
      urlCancelDelete: this.$API_URL + "permit/cancel_delete",
      urlPrint: this.$API_URL + "permit/downloadprint",
      dataModel: null,
      loading: true,
      totalRecords: 0,
      start: 0,
      pageSize: 10,
      stateKey: this.$STATE_NAME + "permit-" + this.$store.getters.getUsername,
      timezoneUserOffset: this.$store.getters.getTimezoneOffset,
      role: this.$store.getters.getRole,
      isAdmin: this.$store.getters.getIsAdmin,
      isUser: this.$store.getters.getIsUser,
      isTransporter: this.$store.getters.getIsTransporter,
      isDriver: this.$store.getters.getIsDriver,
      companyUser: this.$store.getters.getCompanyCode,
      companyUserId: this.$store.getters.getCompanyId,
      username: this.$store.getters.getUsername,
      sorts: null,
      statusUrl: "permit/status",
      lazyParams: {},
      filters: null,
      workData: null,
      stateFilters: null,
      editorPath: "/Permit/Editor",
      editorWorkPath: "/Work/Editor",
      dataUrl: "permit/list",
      typeUrl: "permit/status_company_intrans",
      dataStartUrl: "permit/run",
      releaseUrl: "permit/release",
      canCreate: false,
      isHaveOsPermit: false,
      errMessage: null,
      canEdit: false,
      canDelete: false,
      canView: false,
      selectedRow: null,
      selectCompany: false,
      showApprovalConfirmationModal: false,
      category: "",
      type: "",
      selectedType: null,
      selectedCategoryIndex: 0,
      selectedTypeIndex: 0,
      dataPermitOS: null,
      isAdvancedConPermit: "N",
    };
  },
  methods: {
    onAuth(event) {
      this.canCreate = event.canCreate;
      this.canEdit = event.canEdit;
      this.canDelete = event.canDelete;
      this.canView = event.canView;
    },
    onPage(event) {
      this.pageSize = event.rows;
      this.start = event.first;
      this.loadLazyData();
    },
    onSort(event) {
      this.sorts = event.multiSortMeta;
      this.loadLazyData();
    },
    rowClass(data) {
      if (data.IsDeleted == "Y") {
        return "classRed";
      }
    },
    onFilter() {
      this.loadLazyData();
    },
    onSelect(event) {
      this.selectedRow = event.data;
    },
    downloadPrint(event, type, id) {
      this.$emit("block-ui");

      var permitModel = {
        Id: id,
      };
      var self = this;
      this.$axios
        .post(this.urlPrint, permitModel, {
          responseType: "blob",
        })
        .then((response) => {
          if (type == "PDF") {
            const blob = new Blob([response.data], { type: "application/pdf" });
            const url = URL.createObjectURL(blob);
            window.open(url, "_blank");
          } else {
            const url = window.URL.createObjectURL(new Blob([response.data]));

            let fileName = response.headers["content-disposition"]
              .split("filename=")[1]
              .split(";")[0];
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
          }

          self.$emit("unblock-ui");
        })
        .catch(function (err) {
          self.$parent.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "File not found" + err,
            life: 120000,
          });
          self.blocked = false;
          self.$emit("unblock-ui");
          //self.showAssignModal = false;
        });
    },
    onRowExpand(event) {
      this.expandedRows = [];
      this.expandedRows.push(event.data);
    },
    editor(mode, id, status) {
      this.$router.push({
        path: this.editorPath,
        query: { mode: mode, id: id, status: status },
      });
    },
    editorWork(mode, id) {
      this.$router.push({
        path: this.editorWorkPath,
        query: { mode: mode, id: id },
      });
    },
    filter(mode) {
      this.$router.push({ path: this.filterPath, query: { mode: mode } });
    },
    sidebarMessage(event) {
      this.$toast.add(event);
    },
    loadLazyData() {
      this.loading = true;
      this.selectedRow = null;

      this.lazyParams = {
        start: this.start,
        pageSize: this.pageSize,
        sorts: this.dataSort,
        filters: this.dataFilter,
        category: this.selectedStatus,
        type: this.selectedType,
      };

      var self = this;

      this.$axios
        .post(this.$API_URL + this.dataUrl, this.lazyParams)
        .then((response) => {
          if (response.data.success) {
            this.dataModel = response.data.data;
            this.totalRecords = response.data.totalRecords;
          } else {
            self.$toast.add({
              severity: "error",
              summary: "Error",
              detail: response.data.message,
              life: 3000,
            });
          }
          this.loading = false;
        })
        .catch(function (err) {
          self.$toast.add({
            severity: "error",
            summary: "Error",
            detail: err.message,
            life: 3000,
          });
          self.loading = false;
        });
    },
    setFilters() {
      this.filters = {};
      var exportable = this.$refs.dt.columns.filter((c) => c.props.field);
      for (var i = 0; i < exportable.length; i++) {
        var filterValue = null;
        if (this.stateFilters) {
          var field = this.stateFilters[exportable[i].props.field];
          if (field) filterValue = field.value;
        }
        this.filters[exportable[i].props.field] = {
          value: filterValue,
          matchMode: "contains",
        };
      }
    },
    onStateRestore(event) {
      this.start = event.first;
      this.pageSize = event.rows;
      this.stateFilters = event.filters;
      this.sorts = event.multiSortMeta;
    },
    onStateSave(event) {
      event.selectedCategoryIndex = this.selectedCategoryIndex;
      event.selectedTypeIndex = this.selectedTypeIndex;
    },
    editOrder() {
      this.$router.push({
        path: this.editorPath,
        query: { mode: this.$FORM_MODE_EDIT, id: this.selectedRow[0].Id },
      });
    },
    onModalClose() {
      this.loadLazyData();
    },
    clearFilter() {
      this.filters = {};
      var exportable = this.$refs.dt.columns.filter((c) => c.props.field);
      for (var i = 0; i < exportable.length; i++) {
        var fieldName = exportable[i].props.field;
        var filterValue = "";
        if (fieldName.includes("Date")) {
          filterValue = null;
        }
        this.filters[exportable[i].props.field] = {
          value: filterValue,
          matchMode: "contains",
        };
      }
      this.loadLazyData();
    },
    hideSelectCompanyDialog(event) {
      this.selectCompany = false;
      this.errormessage = "";
      this.onModalClose();
      if (event && event.success) {
        this.$toast.add({
          severity: "success",
          summary: "Success",
          detail: event.message.message,
          life: 3000,
        });

        this.editor(this.$FORM_MODE_EDIT, event.message.data);
      }
    },
    confirm(event, mode, id, workid, category) {
      this.$confirm.require({
        target: event.currentTarget,
        message: "Are you sure?",
        icon: "pi pi-exclamation-triangle",
        accept: () => {
          this.copyPermit(mode, id, workid, category);
        },
        reject: () => {
          //callback to execute when user rejects the action
        },
      });
    },
    confirmCancelDelete(event, mode, id, workid, category) {
      this.$confirm.require({
        target: event.currentTarget,
        message: "Are you sure?",
        icon: "pi pi-exclamation-triangle",
        accept: () => {
          this.cancelDeletePermit(mode, id, workid, category);
        },
        reject: () => {
          //callback to execute when user rejects the action
        },
      });
    },
    copyPermit(mode, id, workid, category) {
      var self = this;

      this.$emit("block-ui");

      this.$axios
        .post(this.urlInit, {
          mode: this.$FORM_MODE_CREATE,
          Id: id,
          WorkId: workid,
          Category: category,
          isCopy: "Y",
          TimeZoneOffset: this.timezoneUserOffset,
        })
        .then((response) => {
          if (response.data.success) {
            self.$toast.add({
              severity: "success",
              summary: "Success Continue Permit",
              detail: response.data.message,
              life: 3000,
            });
            self.editor(this.$FORM_MODE_EDIT, response.data.data);
          } else {
            self.$toast.add({
              severity: "error",
              summary: "Error Continue Permit",
              detail: response.data.message,
              life: 3000,
            });
          }
          this.$emit("unblock-ui");
        })
        .catch((err) => {
          this.$emit("unblock-ui");
          self.$toast.add({
            severity: "error",
            summary: "Error",
            detail: err.message,
            life: 3000,
          });
        });
    },
    cancelDeletePermit(mode, id, workid, category) {
      var self = this;

      this.$emit("block-ui");

      this.$axios
        .post(this.urlCancelDelete, {
          mode: mode,
          Id: id,
          WorkId: workid,
          Category: category,
        })
        .then((response) => {
          if (response.data.success) {
            self.$toast.add({
              severity: "success",
              summary: "This Permit is cancelled from deletion",
              detail: response.data.message,
              life: 3000,
            });
          } else {
            self.$toast.add({
              severity: "error",
              summary: "Error cancelled from deletion",
              detail: response.data.message,
              life: 3000,
            });
          }
          self.loadLazyData();
          this.$emit("unblock-ui");
        })
        .catch((err) => {
          this.$emit("unblock-ui");
          self.$toast.add({
            severity: "error",
            summary: "Error",
            detail: err.message,
            life: 3000,
          });
        });
    },
    blockUI() {
      this.$emit("block-ui");
    },
    unblockUI() {
      this.$emit("unblock-ui");
    },
    initWork() {
      this.selectCompany = true;
    },
    showError(summary, message) {
      this.$emit("unblock-ui");
      this.$toast.add({
        severity: "error",
        summary: summary,
        detail: message,
        life: 3000,
      });
    },
    goToDetail(event) {
      var data = event.data;

      let routeData = this.$router.resolve({
        name: "PermitEditor",
        query: { mode: this.$FORM_MODE_VIEW, id: data.permitId },
      });
      window.open(routeData.href, "_blank");
    },
    onStatusChange(event) {
      this.selectedStatus = event.value;

      this.selectedCategoryIndex = event.index;
      this.selectedTypeIndex = event.index;
      this.$refs.dt.triggerSaveState();
      this.setFilters();
      this.$toast.removeAllGroups();
      this.loadLazyData();
    },
    onTypeChange(event) {
      this.selectedType = event.value;
      this.selectedTypeIndex = event.index;
      this.$refs.dt.triggerSaveState();
      this.setFilters();
      this.loadLazyData();
    },
    processSelectedData(status) {
      this.showApprovalConfirmationModal = true;
      this.confirmationStatus = status;
    },
    confirmApproval() {
      this.$emit("blockBody");
      var self = this;

      self.invalid = false;

      // if (this.checkRemarks())
      //     return;

      var data = {
        data: this.selectedDocuments,
        status: this.confirmationStatus,
      };

      self.processing = true;

      this.$axios
        .put(this.$API_URL + this.releaseUrl, data)
        .then((response) => {
          self.processing = false;
          if (response) {
            this.$emit("unblockBody");
            if (response.data.success) {
              self.$toast.add({
                severity: "success",
                summary: "Data Saved",
                detail: response.data.message,
                life: 3000,
              });
              self.showApprovalConfirmationModal = false;
              self.processed = false;
              self.loadLazyData();
            } else {
              if (response.data.message_code == "HAVE_OS_PERMIT") {
                self.dataPermitOS = response.data.data;
                self.isHaveOsPermit = true;
                self.errMessage = response.data.message;
              }
              self.$toast.add({
                severity: "error",
                summary: "Error",
                detail: response.data.message,
                life: 3000,
              });
              self.showApprovalConfirmationModal = false;
              self.processed = false;
            }
          } else {
            self.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "No Response",
              life: 3000,
            });
          }
        })
        .catch(function (error) {
          self.processed = false;
          self.processing = false;

          self.$toast.add({
            severity: "error",
            summary: "Error",
            detail: error,
            life: 3000,
          });
        });
    },
    dismissConfirmation() {
      this.processed = false;
      this.showApprovalConfirmationModal = false;
      this.loadLazyData();
    },
    checkRemarks() {
      var result = false;

      var self = this;
      self.invalid = false;

      // if (!this.selectedStatus.toLowerCase().includes("appointment")) {
      //     return false;
      // }

      // if (this.confirmationStatus == this.$APPROVAL_STATUS.APPROVED) {
      //     return false;
      // }

      for (var x = 0; x < this.selectedRow.length; x++) {
        var doc = this.selectedRow[x];

        if (doc.Remarks == "" || doc.Remarks == null) {
          self.invalid = true;
          result = true;
          break;
        }
      }

      return result;
    },
  },
  mounted() {
    this.$emit("unblock-ui");
    this.setFilters();

    var self = this;

    this.$axios
      .get(this.$API_URL + this.statusUrl)
      .then((response) => {
        if (response.data.success) {
          self.statusList = response.data.data;
          var selectedStatusValue = Object.values(this.statusList)[
            this.selectedCategoryIndex
          ];
          if (selectedStatusValue == undefined) {
            self.selectedStatus = Object.values(this.statusList)[0];
          } else {
            self.selectedStatus = selectedStatusValue;
          }
        } else {
          self.$toast.add({
            severity: "error",
            summary: "Error",
            detail: response.data.message,
            life: 3000,
          });
        }

        self.loading = false;
      })
      .catch(function (err) {
        //console.log(self);
        self.$toast.add({
          severity: "error",
          summary: "Error",
          detail: err,
          life: 3000,
        });
        self.loading = false;
      });

    this.$axios
      .get(this.$API_URL + this.typeUrl)
      .then((response) => {
        //console.log(response)
        if (response.data.success) {
          self.typeList = response.data.data;
          var selectedTypeValue = Object.values(this.typeList)[
            this.selectedTypeIndex
          ];
          if (selectedTypeValue == undefined) {
            self.selectedType = Object.values(this.typeList)[0];
          } else {
            self.selectedType = selectedTypeValue;
          }

          self.loadLazyData();
        } else {
          self.$toast.add({
            severity: "error",
            summary: "Error",
            detail: response.data.message,
            life: 3000,
          });
        }

        self.loading = false;
      })
      .catch(function (err) {
        //console.log(self);
        self.$toast.add({
          severity: "error",
          summary: "Error",
          detail: err,
          life: 3000,
        });
        self.loading = false;
      });
  },
  computed: {
    dataFilter() {
      var h = [];
      if (this.filters) {
        for (const [key, value] of Object.entries(this.filters)) {
          h.push({
            field: key ? key : null,
            value: value.value,
            matchMode: value.matchMode,
          });
        }
      }
      return h;
    },
    dataSort() {
      var h = [];
      if (this.sorts) {
        for (var x = 0; x < this.sorts.length; x++) {
          h.push({
            field: this.sorts[x].field,
            order: this.sorts[x].order == 1 ? "ASC" : "DESC",
          });
        }
      }
      return h;
    },
    filterBadge() {
      var badgeNumber = 0;

      this.dataFilter.filter(function (item) {
        if (item.value && item.field != "Status") {
          badgeNumber++;
        }
      });

      return badgeNumber;
    },
    all() {
      return this.selectedCategoryIndex == 0;
    },
    unrel() {
      return this.selectedCategoryIndex == 1;
    },
    rel() {
      return this.selectedCategoryIndex == 2;
    },
    inprogress() {
      return this.selectedCategoryIndex == 3;
    },
    rejecteed() {
      return this.selectedCategoryIndex == 4;
    },
    completed() {
      return this.selectedCategoryIndex == 5;
    },
    closed() {
      return this.selectedCategoryIndex == 6;
    },
    selectedDocuments() {
      var data = [];

      if (this.selectedRow == null) return data;

      for (var x = 0; x < this.selectedRow.length; x++) {
        var row = this.selectedRow[x];
        var d = {
          id: row.Id,
          remarks: row.PermitUser,
          ref_no: row.PermitNumber,
        };

        data.push(d);
      }

      return data;
    },
  },
};
</script>

<style #scoped>
.p-card .p-card-content {
  margin: 0 !important;
  padding: 0 !important;
}

#dataPermit .classRed {
  background-color: #f85656 !important;
}
</style>
